import React from 'react';
import '../styles/CompTypeSelection.css';
import { Radio } from '../components';

function CompTypeSelection(props) {
    const compTypeSelectionVal = props.compTypeSelectionVal;
    const setCompTypeSelectionVal = props.setCompTypeSelectionVal;

    const options = [
        {
            label: "ARV",
            value: "arv",
            selected: compTypeSelectionVal === "arv" ? true : false
        },
        {
            label: "As-is",
            value: "as-is",
            selected: compTypeSelectionVal === "as-is" ? true : false
        }
    ];

    const onChangeRadio = (value) => {
        setCompTypeSelectionVal(value);
    };

    return (
        <div className="comp-type-selection-container">
            {
                options.map((item, index) =>
                    <Radio
                        label={item.label}
                        type="regular"
                        selected={item.selected}
                        identifier={item.value}
                        selectRadio={onChangeRadio}
                        key={index}
                    />
                )
            }
        </div>
    )
};

export default CompTypeSelection;